import { render, staticRenderFns } from "./MspValutazioneAllenamento.vue?vue&type=template&id=93360d32"
import script from "./MspValutazioneAllenamento.vue?vue&type=script&lang=js"
export * from "./MspValutazioneAllenamento.vue?vue&type=script&lang=js"
import style0 from "./MspValutazioneAllenamento.vue?vue&type=style&index=0&id=93360d32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports